import { useMemo } from 'react';
import { useFinancialPlanQuery } from '../../../api/useFinancialPlanQuery';
import { useRouteParams } from '../../hooks/useRouteParams';
import { AsyncComponentHookResult } from '../../../../Types/ComponentHookResult';
import { GoalDTO, GoalTypeDTO } from '../../../types/goalsDTO';
import { getGoalPageName } from '../../utils/getGoalPageName';

interface UseFooterData {
  previousGoal: GoalDTO | null;
  nextGoal: GoalDTO | null;
}

interface UseFooterActions {
  navigateToGoal: (goalId: string, goalType: GoalTypeDTO) => void;
}

export const useFooter = (): AsyncComponentHookResult<UseFooterData, UseFooterActions> => {
  const queryResult = useFinancialPlanQuery();
  const { goalId: currentGoalId, clientId } = useRouteParams();

  const data = useMemo(() => {
    if (!queryResult.data) {
      return null;
    }

    const { Goals: goals } = queryResult.data;

    const currentGoalIndex = goals.findIndex(goal => goal.GoalId === currentGoalId);

    if (currentGoalIndex === -1) {
      return null;
    }

    const previousGoal = currentGoalIndex > 0 ? goals[currentGoalIndex - 1] : null;
    const nextGoal = currentGoalIndex !== goals.length - 1 ? goals[currentGoalIndex + 1] : null;

    return {
      previousGoal,
      nextGoal,
    };
  }, [currentGoalId, queryResult.data]);

  const navigateToGoal = (goalId: string, goalType: GoalTypeDTO) => {
    const goalPageName = goalType ? getGoalPageName(goalType) : 'NewFinancialPlanWhatIfs';

    ADV.util.Router.go2(goalPageName, {
      clientId,
      goalId,
    });
  };

  return {
    ...queryResult,
    data,
    actions: {
      navigateToGoal,
    },
  };
};
